import { Quadkey } from '@xyo-network/sdk-xyoworld-js'
import React from 'react'
import { Helmet } from 'react-helmet'
import { useParams } from 'react-router-dom'

import { QuadkeyHeader } from '../../Toolbar'
import WorldBasePage from '../WorldBasePage'

const ThingPage: React.FC = () => {
  const { id } = useParams()
  const quadkeyRequested = Quadkey.fromBase4String(id) ?? Quadkey.root

  return (
    <WorldBasePage>
      <Helmet title="Thing" />
      <QuadkeyHeader quadkey={quadkeyRequested} />
    </WorldBasePage>
  )
}

export default ThingPage
